<template>
  <!-- 产品热销 -->
  <div>
    <div class="search-box min">
      <div class="input-item">
        <span class="label">产品名称</span>
        <Input v-model="searchParams.productName" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">产品编码</span>
        <Input v-model="searchParams.productCode" placeholder="请输入" clearable />
      </div>
      <div class="btn-item">
        <Button type="primary" @click="getList()">搜索</Button>
        <Button type="primary" ghost @click="$refs.editModal.open({})">+ 新增</Button>
      </div>
    </div>
    <Tabs v-model="searchParams.parentId" :animated="false" @on-click="getList()" type="card" :before-remove="removeTab">
      <TabPane v-for="bean in typeList" :key="bean.id" :name="bean.id" :label="bean.name" :closable="bean.name != '平台热卖'"></TabPane>
      <div class="tab-other-btn" slot="extra">
        <span class="table-btn" @click="$refs.categorizeFormModal.open({})">新增栏目</span>
        <span class="table-btn" @click="$refs.categorizeList.open(typeList)">管理栏目</span>
      </div>
    </Tabs>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData" v-if="tableData.length">
        <template slot-scope="{ row }" slot="img">
          <div class="img-content" :class="{ 'first': row.imgType == '1' }">
            <div class="img-box-mask"></div>
            <div class="img-box" v-if="row.img">
              <img :src="row.img" class="img" />
              <div class="img-info-box">
                <div class="img-title">{{ row.title }}</div>
                <div class="img-text">{{ row.profile }}</div>
                <div class="img-fee" v-if="row.isShowCommission == 1">
                  <p class="text1">{{$units.isOkBao() ? '推广费最高' : '服务费最高'}}</p>
                  <p class="text2">XX.XX%</p>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 上下架 -->
        <template slot-scope="{ row }" slot="publishStatus">
          <span v-if="row.publishStatus == 2">已上架</span>
          <span v-else>已下架</span>
        </template>
        <!-- 销售状态 -->
        <template slot-scope="{ row }" slot="salesStatus">
          <span v-if="row.salesStatus == 2">在售</span>
          <span v-else>停售</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="$refs.editModal.open(row)">编辑</span>
          <span class="table-btn red" @click="del(row.id)">删除</span>
        </template>
      </Table>
      <no-data v-else-if="!listLoading" style="margin-top: 250px"></no-data>
    </div>

    <!-- 详情 -->
    <edit-modal ref="editModal" @reload="init()" :typeList="typeList" :parentId="searchParams.parentId" />
    <!-- 新增、编辑分类 -->
    <categorize-form-modal ref="categorizeFormModal" @reload="getTypeList" />
    <!-- 管理分类 -->
    <categorize-list ref="categorizeList" :typeList="typeList" @reload="categorizeReload"/>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
  </div>
</template>

<script>
import { pageTool } from '@/api/mixins';
import { config } from './hotProductConfig2.config.js';
import editModal from './components/editModal';
import categorizeFormModal from './components/categorizeFormModal';
import categorizeList from './components/categorizeList';
import confirmModal from '@/components/commons/confirmModal';
export default {
  mixins: [pageTool, config],
  components: {
    editModal,
    confirmModal,
    categorizeList,
    categorizeFormModal,
  },
  data() {
    return {
      typeList: [], //栏目列表
      searchParams: {
        parentId: '',
      }
    };
  },
  computed: {
    curTab() {
      if (!this.typeList || this.typeList.length == 0) {
        return {};
      }
      const data = this.typeList.find(item => item.id == this.searchParams.parentId);
      if (data) {
        return data;
      } else {
        return {};
      }
    }
  },
  async activated() {
    await this.getTypeList();
    this.getList();
  },
  methods: {
    async categorizeReload(id) {
      await this.init(id);
      this.$refs.categorizeList.open(this.typeList);
    },
    // id:被删除的id
    async init(id) {
      // 当前栏目被删除
      if (this.searchParams.parentId == id) {
        this.searchParams.parentId = '';
      }
      await this.getTypeList();
      this.getList();
    },
    del(id) {
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '请确认是否删除，删除后将无法恢复！'
        })
        .then(() => {
          this.listLoading = true;
          this.$http({
            url: '/buz/exhibitionPicConfig/delSellCard',
            type: 'GET',
            data: {
              id: id
            }
          }).then(res => {
            this.$notice.success('删除成功');
            this.init();
          }).finally(()=>{
            this.listLoading = false;
          });
        })
        .catch(e => {});
    },
    beforeRemoveTab(index){
      console.log(a);
      return Promise.reject();
    },
    // 删除分类
    removeTab(index) {
      const data = this.typeList[index];
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: `是否要删除此栏目：${data.name}，删除后此栏目下的配置将会被清空`
        })
        .then(() => {
          this.listLoading = true;
          this.$http({
            url: '/buz/exhibitionPicConfigType/deleteCardType',
            type: 'GET',
            data: {
              id: data.id
            }
          }).then(res => {
            this.$notice.success('删除成功');
            this.init(data.id);
          }).finally(()=>{
            this.listLoading = false;
          });
        })
        .catch(e => {});
      return Promise.reject();
    },
    // 获取分类
    getTypeList() {
      return this.$http({
        url: '/buz/exhibitionPicConfigType/read/cardTypeList',
        type: 'GET',
        data: {}
      }).then(res => {
        const list = res.data;
        // 默认选中
        if (list && list[0]) {
          this.typeList = list;
          const current = list.find(item => item.id == this.searchParams.parentId);
          // 当前栏目为空或者当前栏目不存在
          if (!this.searchParams.parentId || !current) {
            this.searchParams.parentId = list[0].id;
          }
        } else {
          this.typeList = [];
        }
        return list;
      });
    },
    getList() {
      this.getColumns();
      this.listLoading = true;
      this.$http({
        url: '/buz/exhibitionPicConfig/read/sellCard',
        type: 'POST',
        data: this.searchParams
      })
        .then(res => {
          this.tableData = res.data;
        })
        .finally(() => {
          this.listLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './hotProductConfig2.scss';
</style>
